var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM25.875 13.4167H28.75V17.25H25.875C25.6208 17.25 25.3771 17.351 25.1974 17.5307C25.0176 17.7104 24.9167 17.9542 24.9167 18.2083V21.0833H28.75L27.7917 24.9167H24.9167V32.5833H21.0833V24.9167H18.2083V21.0833H21.0833V18.2083C21.0833 16.9375 21.5882 15.7187 22.4868 14.8201C23.3854 13.9215 24.6042 13.4167 25.875 13.4167Z",
    fill: "#1E1619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookM);
export default __webpack_public_path__ + "static/media/facebookM.e5cd4401ff5ec06fc32ff805330f06f6.svg";
export { ForwardRef as ReactComponent };